(function () {
  'use strict';
  if (window.healthyTeamLanding) return;
  window.healthyTeamLanding = true;
  var key = 'healthy-italia:event-lead:v1';
  var lifetime = 2 * 60 * 60 * 1000;
  function read() {
    try {
      var lead = JSON.parse(sessionStorage.getItem(key));
      if (lead && Date.now() - lead.savedAt < lifetime && typeof lead.name === 'string' && lead.name.trim() && typeof lead.email === 'string' && lead.email.trim() && typeof lead.phone === 'string' && lead.phone.trim()) return lead;
    } catch (error) { /* Storage may be unavailable or contain an old value. */ }
    return null;
  }
  function localURL(value) {
    if (!value) return null;
    try {
      var url = new URL(value, location.origin);
      return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null;
    } catch (error) { return null; }
  }
  function init(scope) {
    scope.querySelectorAll('[data-team-landing]').forEach(function (root) {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      var form = root.querySelector('form');
      var errorBox = root.querySelector('[data-lead-error]');
      var lead = read();
      var success = root.querySelector('[data-lead-success]');
      var destination = localURL(root.dataset.bookingUrl);
      function fail() {
        errorBox.textContent = root.dataset.storageError;
        errorBox.hidden = false;
      }
      if (success) {
        // Only promote the pending details after Shopify renders its successful submission state.
        if (lead && destination && !(window.Shopify && Shopify.designMode)) {
          try {
            lead.captured = true;
            sessionStorage.setItem(key, JSON.stringify(lead));
            document.dispatchEvent(new CustomEvent('healthyitalia:lead-captured', { detail: lead }));
            var save = function () {
              errorBox.hidden = true;
              window.HealthyEventRequest.contact(root).then(function () { location.replace(destination.href); })
                .catch(function () { errorBox.textContent = 'Unable to save your request. Please use Continue to retry.'; errorBox.hidden = false; });
            };
            success.querySelector('a').addEventListener('click', function (event) { event.preventDefault(); save(); });
            save();
          } catch (error) { fail(); }
        }
        return;
      }
      ['name', 'email', 'phone'].forEach(function (name) {
        var input = form.elements.namedItem('contact[' + name + ']');
        if (lead && !input.value) input.value = lead[name];
        input.addEventListener('input', function () { input.setCustomValidity(''); });
      });
      form.addEventListener('submit', function (event) {
        if (window.Shopify && Shopify.designMode) { event.preventDefault(); return; }
        var details = { savedAt: Date.now(), captured: false };
        ['name', 'email', 'phone'].forEach(function (name) {
          var input = form.elements.namedItem('contact[' + name + ']');
          input.value = input.value.trim();
          details[name] = input.value;
        });
        if (!form.reportValidity()) { event.preventDefault(); return; }
        try {
          sessionStorage.setItem(key, JSON.stringify(details));
          // Keep the native Shopify submission, validation and spam challenge intact.
        } catch (error) { event.preventDefault(); fail(); }
      });
    });
    scope.querySelectorAll('[data-team-booking-gate]').forEach(function (root) {
      if (root.dataset.gateInitialized) return;
      root.dataset.gateInitialized = 'true';
      var lead = read();
      var editor = window.Shopify && Shopify.designMode;
      if (!editor && (!lead || !lead.captured)) {
        var landing = localURL(root.dataset.landingUrl);
        if (landing && landing.pathname !== location.pathname) location.replace(landing.href);
        return;
      }
      root.hidden = false;
      if (!lead) return;
      var parts = lead.name.trim().split(/\s+/);
      var values = { firstName: parts.shift(), lastName: parts.join(' '), email: lead.email, phone: lead.phone };
      try {
        var quote = JSON.parse(sessionStorage.getItem('healthy-italia:event-quote:v2'));
        if (quote && Date.now() - quote.savedAt < lifetime && !root.hasAttribute('data-event-quote')) {
          values.estimatedGuestCount = quote.headcount;
          values.notes = String(quote.notes || '').slice(0, 2000);
          root.querySelectorAll('[name="menu"]').forEach(function (input) {
            if (input.value === quote.packageName) { input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        }
      } catch (error) { /* Ignore invalid or expired quote drafts. */ }
      Object.keys(values).forEach(function (name) {
        var input = root.querySelector('[name="' + name + '"]');
        if (input && !input.value) input.value = values[name];
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
